import { render, staticRenderFns } from "./NewEditSettingsTemplateDialog.vue?vue&type=template&id=1b0a83fe&scoped=true"
import script from "./NewEditSettingsTemplateDialog.vue?vue&type=script&lang=js"
export * from "./NewEditSettingsTemplateDialog.vue?vue&type=script&lang=js"
import style0 from "./NewEditSettingsTemplateDialog.vue?vue&type=style&index=0&id=1b0a83fe&prod&lang=scss&scoped=true"
import style1 from "./NewEditSettingsTemplateDialog.vue?vue&type=style&index=1&id=1b0a83fe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0a83fe",
  null
  
)

export default component.exports